import { render, staticRenderFns } from "./merit.vue?vue&type=template&id=dff8e812&scoped=true"
import script from "./merit.vue?vue&type=script&lang=js"
export * from "./merit.vue?vue&type=script&lang=js"
import style0 from "./merit.vue?vue&type=style&index=0&id=dff8e812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8e812",
  null
  
)

export default component.exports